import { Component, inject, Inject, Input, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { signalState } from '@ngrx/signals';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'app-allocate-beneficiary-hpv-session-modal.component',
  templateUrl: './allocate-beneficiary-hpv-session-modal.component.html',
  styleUrls: ['./allocate-beneficiary-hpv-session-modal.component.scss'],
})
export class AllocateBeneficiaryHPVSessionModalComponent implements OnInit {
  hpvForm: FormGroup;
  readonly modalController = inject(ModalController);
  readonly util = inject(UtilsService);
  readonly sessionService = inject(SessionService);
  destroy$ = new Subject();
  @Input() benfDetails: any = {};
  @Input() sessionData: any = {};
  isLoading: boolean = false;
  constructor() {}

  ngOnInit() {
    console.log('benfDetailsbenfDetailsbenfDetails', this.benfDetails);
    this.initForm();
  }

  initForm() {
    this.hpvForm = new FormGroup({
      mobile_number: new FormControl('', [
        Validators.required,
        Validators.pattern(/[6-9]{1}[0-9]{9}/),
      ]),
      is_hpv_vaccinated: new FormControl(''),
      hpv_vaccination_date: new FormControl(''),
      hpv_material_id: new FormControl(''),
      hpv_material_other: new FormControl(''),
      hpv_vaccinated_at_public: new FormControl(''),
      vaccine_consent: new FormControl(null, [Validators.requiredTrue]),
    });
  }

  closeDialog() {
    this.modalController.dismiss(false);
  }
  onSubmit() {
    console.log(this.util.findInvalidControls(this.hpvForm));

    if (!this.hpvForm.valid) {
      this.util.presentToastError('Please enter required fields');
      return;
    }
    if (
      this.hpvForm.get('mobile_number').value !=
      this.benfDetails['ben_mobile_number']
    ) {
      this.util.presentToastError(
        'Mobile Number did not match with selected beneficiary.'
      );
      return;
    }
    if (!this.hpvForm.get('is_hpv_vaccinated').value) {
      this.modalController.dismiss(true);
      return;
    }
    const payload = {
      beneficiary_id: this.benfDetails.beneficiary_id,
      // is_hpv_vaccinated_outside: true,
      // is_hpv_vaccinated: this.hpvForm.get('is_hpv_vaccinated').value,
      hpv_material_other:
        this.hpvForm.get('hpv_material_other').value ?? undefined,
      hpv_material_id:
        this.hpvForm.get('hpv_material_id').value !== 'other'
          ? this.hpvForm.get('hpv_material_id').value
          : undefined,
      hpv_vaccinated_at_public: this.hpvForm.get('hpv_vaccinated_at_public')
        .value,
      hpv_vaccination_date: moment(
        this.hpvForm.get('hpv_vaccination_date').value
      ).format('YYYY-MM-DD'),
    };
    this.isLoading = true;
    this.sessionService.updateOldHpvVaccinations(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.modalController.dismiss(true);
      },
      error: (err) => {
        this.isLoading = false;
      },
    });
  }
}
